<template>
  <div class="prodotti">
    <div class="offset-2 col-20 no-padding" v-loading="loading">
      <el-table
        :data="prodotti"
        class="col-24 no-padding custom-table">
        <el-table-column
          prop="codProd"
          :label="$t('prodotti.codice')"
          min-width="60">
        </el-table-column>
        <el-table-column
          prop="desProd"
          :label="$t('prodotti.descrizione')"
          min-width="220">
        </el-table-column>
        <el-table-column
          prop="codEurofer"
          :label="$t('prodotti.eurofer')"
          min-width="60">
        </el-table-column>
        <el-table-column
          prop="codCECA"
          :label="$t('prodotti.ceca')"
          min-width="60">
        </el-table-column>
        <el-table-column
          v-if="saved.ifRifiuto === '1'"
          prop="codCER"
          :label="$t('prodotti.CER')"
          min-width="80">

          <template slot-scope="scope">
            <div class="name-wrapper">
              <el-select 
                v-if="scope.row.codiciCER && scope.row.qtaDic"
                class="custom-select-el select-codici-cer"
                v-model="scope.row.codCER"
                placeholder=""
                @change="(value) => changeCodCER(value, scope.$index)"
              >
                <el-option
                  v-for="item in scope.row.codiciCER"
                  :key="item.codCER"
                  :label="item.codCER"
                  :value="item.codCER">
                </el-option>
              </el-select>
            </div>
          </template>

        </el-table-column>
        <el-table-column
          v-else
          prop="codCER"
          :label="$t('prodotti.CER')"
          min-width="60">
        </el-table-column>
        <el-table-column
          prop="qtaDic"
          :label="$t('prodotti.qta')"
          min-width="90">

          <template slot-scope="scope">
            <div class="name-wrapper">
              <el-input class="custom-input" v-model="scope.row.qtaDic" @change="changeQtaTot" @input="formatNumber(scope.$index)" :maxlength=11></el-input>
            </div>
          </template>

        </el-table-column>

      </el-table>
      <div class="qta-tot col-24 no-padding">
        <span>{{ $t('prodotti.qtaTot') }}: </span>
        &nbsp;&nbsp;
        <span class="value">{{ qtaTot + ((qtaTot !== '') ? ' Kg' : '') }}</span>
      </div>
    </div>
    <div class="button offset-1 col-22">
      <el-button class="custom-button" @click="back">{{$t('prodotti.indietro').toUpperCase()}}</el-button>
      <el-button class="custom-button" type="primary" @click="avanti" :loading="loadingButton">{{ $t('prodotti.avanti').toUpperCase() }}</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Prodotti',
    props: ['form', 'conf', 'buono', 'saved'],
    data () {
      return {
        codLang: sessionStorage.getItem('codLang'),
        prodotti: [],
        qtaTot: '',
        loading: true,
        loadingButton: false
      }
    },
    i18n: {
      messages: {
        it_IT: {
          prodotti: {
            codice: 'Codice',
            descrizione: 'Descrizione',
            eurofer: 'Eurofer',
            ceca: 'Ceca',
            qta: 'Quantità (Kg)',
            qtaTot: 'Quantità totale',
            avanti: 'Avanti',
            indietro: 'Indietro',
            errorQtaTot: 'La quantità totale inserita deve essere maggiore di 0',
            CER: 'EER'
          }
        },
        fr_FR: {
          prodotti: {
            codice: 'Code',
            descrizione: 'Description',
            eurofer: 'Eurofer',
            ceca: 'Ceca',
            qta: 'Quantité (Kg)',
            qtaTot: 'Quantité totale',
            avanti: 'Suivant',
            indietro: 'Precedent',
            errorQtaTot: 'La quantité totale entrée doit être supérieure à 0',
            CER: 'CER'
          }
        },
        es_ES: {
          prodotti: {
            codice: 'Codigo',
            descrizione: 'Descrpción',
            eurofer: 'Eurofer',
            ceca: 'Ceca',
            qta: 'Cantidad (Kg)',
            qtaTot: 'Cant. total',
            avanti: 'Adelante',
            indietro: 'Atrás',
            errorQtaTot: 'La cantidad total ingresada debe ser mayor que 0',
            CER: 'CER'
          }
        },
        de_DE: {
          prodotti: {
            codice: 'Kode',
            descrizione: 'Beschreibung',
            eurofer: 'Eurofer',
            ceca: 'Ceca',
            qta: 'Menge (Kg)',
            qtaTot: 'Gesamtmenge',
            avanti: 'Vorwärts',
            indietro: 'Zurück',
            errorQtaTot: 'Die eingegebene Gesamtmenge muss größer als 0 sein',
            CER: 'CER'
          }
        },
        en_GB: {
          prodotti: {
            codice: 'Code',
            descrizione: 'Description',
            eurofer: 'Eurofer',
            ceca: 'Ceca',
            qta: 'Quantity (Kg)',
            qtaTot: 'Total quantity',
            avanti: 'Next',
            indietro: 'Back',
            errorQtaTot: 'The total quantity entered must be greater than 0',
            CER: 'CER'
          }
        }
      }
    },
    mounted: function () {
      this.prodotti = JSON.parse(JSON.stringify(this.saved.prodotti))
      this.getQtaTot()
      for (const [index, prodotto] of this.prodotti.entries()) {
        if (this.saved.ifRifiuto === '1' && prodotto.qtaDic) {
          this.getCodCER(prodotto, index)
        }
      }
    },
    computed: {
      ifQtaTot: function () {
        return (parseInt(this.qtaTot.split('.').join('')) > 0)
      }
    },
    methods: {
      changeCodCER: function (value, index) {
        const codiceObj = this.prodotti[index].codiciCER.find(codice => codice.codCER === value)
        if (codiceObj) {
          this.$set(this.prodotti[index], 'prodMag', codiceObj.prodMag)
        }
      },
      getCodCER: function (prodotto, index) {
        if (this.prodotti[index].loadingCodiciCER) {
          return
        }
        this.$set(this.prodotti[index], 'loadingCodiciCER', true)
        this.$http.get('buonidiscarico/codicicer', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            codSoc: this.form.stab.codSoc,
            codStab: this.form.stab.codStab,
            prodotto: prodotto.codProd
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this.prodotti[index], 'codiciCER', response.body.data)
              // Se il prodotto non ha gia' un codice CER assegnato lascio la select vuota
              this.$set(this.prodotti[index], 'codCER', this.prodotti[index].codCER ? this.prodotti[index].codCER : '')
              this.$set(this.prodotti[index], 'prodMag', this.prodotti[index].prodMag ? this.prodotti[index].prodMag : '')
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this.prodotti[index], 'loadingCodiciCER', false)
          }, response => {
            this.$message({
              showClose: true,
              message: 'Errore durante la richiesta dei codici CER',
              type: 'error',
              duration: process.env.duration
            })
            this.$set(this.prodotti[index], 'loadingCodiciCER', false)
          })
      },
      dotSeparateNumber: function (val) {
        while (/(\d+)(\d{3})/.test(val.toString())) {
          val = val.toString().replace(/(\d+)(\d{3})/, '$1'+'.'+'$2')
        }
        return val
      },
      formatNumber: function (index) {
        // Controllo se il buono è di rottame di rifiuto
        // e se non ho ancora valorizzato l'elenco dei codici CER per il prodotto
        if (this.saved.ifRifiuto === '1' && !this.prodotti[index].codiciCER) {
          this.getCodCER(this.prodotti[index], index)
        }

        let patt = /[^0-9]+/g
        for (let i = 0; i < this.prodotti.length; i++) {
          // this.prodotti[i].qtaDic = this.prodotti[i].qtaDic.replace(/\./g, '')
          this.prodotti[i].qtaDic = this.prodotti[i].qtaDic.replace(patt, '')
          this.prodotti[i].qtaDic = this.dotSeparateNumber(this.prodotti[i].qtaDic)
        }
      },
      changeQtaTot: function () {
        this.getQtaTot()
      },
      avanti: function () {
        this.getQtaTot(true)
      },
      back: function () {
        this.$emit('indietro')
      },
      getQtaTot: function (flagAvanti) {
        if (flagAvanti === true) {
          this.$set(this, 'loadingButton', true)
        }
        let data = {
          codLang: this.codLang,
          country: this.form.country,
          codForn: this.form.fornitore.codForn,
          tipoForn: this.form.fornitore.tipForn,
          codSoc: this.form.stab.codSoc,
          codStab: this.form.stab.codStab,
          numConf: this.conf.numConf,
          numBuono: this.buono.numBuono,
          prodotti: this.prodotti
        }
        this.$http.post('buonidiscarico/qtatot', data)
          .then(response => {
            if (response.body.rc === 0) {
              this.qtaTot = response.body.data.qtaTot
              if (flagAvanti === true && this.qtaTot !== '') {
                let obj = {
                  prodotti: this.prodotti,
                  qtaTot: this.qtaTot,
                  ifRifiuto: this.saved.ifRifiuto
                }
                this.$emit('avanti', 2, obj)
              } else if (flagAvanti === true && this.qtaTot === '') {
                this.$message({
                  showClose: true,
                  message: this.$t('prodotti.errorQtaTot'),
                  type: 'error',
                  duration: process.env.duration
                })
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.loading = false
            this.$set(this, 'loadingButton', false)
          }, response => {
            console.log(response)
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .prodotti {
    .el-table {
      tbody {
        .cell {
          .custom-input {
            .el-input__inner {
              height: 22px !important;
              padding: 0 5px;
              border: 1px solid #dcdfe6;
            }
          }
          .select-codici-cer {
            width: 100%;
            .el-input__inner {
            height: 22px !important;
            padding: 0 5px;
            border: 1px solid #dcdfe6;
            }
          }
        }
      }
    }
    .qta-tot {
      margin-top: 30px;
      margin-bottom: 50px;
      text-align: right;
      .set-font(@size: 14px);
      .value {
        .set-font(@weight: bold, @size: 18px);
      }
    }
    .button {
      margin-top: 10px;
      text-align: right;
      margin-bottom: 15px; 
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Rottame/WebGestioneRottame/Prodotti.vue